import { Injectable } from "@angular/core";
import { ApiHttpResponseError } from "../models/http/api-http-response-error";
import { NotificationTypeEnum } from "../models/notifications/notification-record";
import momentImported from 'moment';
import { NotificationsService } from "./notification.service";

const moment = momentImported;

export abstract class ApiHttpClientNotificationService {
        abstract notifyError(error: ApiHttpResponseError);
}

@Injectable()
export class DefaultApiHttpClientNotificationService extends ApiHttpClientNotificationService {
    
    constructor(protected notificationService: NotificationsService) { 
            super();
    }

    notifyError(error: ApiHttpResponseError){
            this.notificationService.add({ message: `Request error [${moment().format("L LTS")}]: ${error.message}.`, type: NotificationTypeEnum.Error });
    }
}